// Function for filling the form automatically.

export function fakeUser(){
/////////////////
        let myForm = document.querySelector('#fy-register-form');
        let setFormField = (name: string, value : string) => {
            let ele = (myForm.querySelector("input[name=\""+name+"\"]") as HTMLInputElement);
            ele.value = value;
        }
        setFormField("last_name", "Lee");
        setFormField("first_name", "Leon");
        // setFormField("username", "leon");
        setFormField("useremail", "itdog63@gmail.com");
        setFormField("user_age", "11");
        setFormField("user_HK_id", "A123456(7)");
        setFormField("phone_number", "62829126");

        let genderField = document.querySelector('select[name="user_gender"]') as HTMLInputElement;
        genderField.value = "M";

        let accept_disclaimer = myForm.querySelector("input[name='term_condition']") as HTMLInputElement;
        accept_disclaimer.checked = true;
//////////////
    }